import React,{ useState, useEffect } from "react";
import TextTransition, { presets } from 'react-text-transition';

function RoleBadge({ delay = 0 }) {
  const [isVisible, setIsVisible] = useState(false);
  const [titles, settitles] = useState([
    "Co-founder",
    "CTO",
    "World Economic Forum Top Innovator",
    "Lead Software Engineer",
    "Cloud Architect",
    "Dungeon Master",
    "Senior Fullstack Engineer",
    "Management Engineer"
  ]);

  const [colors, setColors] = useState([
    "#758b99", // Grayish Blue
    "#5e7f64", // Sage Green
    "#6d8891", // Steel Blue
    "#46545e", // Dark Slate Gray
    "#596f7e", // Cadet Blue
    "#677e8e", // Slate Gray
    "#536872", // Dark Cyan
    "#4a5d67", // Gunmetal
    "#47525e", // Dark Steel Blue
    "#394240", // Eerie Black
  ]);

  const [index, setIndex] = useState(0);
  const [isChanging, setIsChanging] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsChanging(true);
      setTimeout(() => {
        setIndex((prevIndex) => (prevIndex + 1) % titles.length);
        setIsChanging(false);
      }, 800); // Increased from 500ms to 800ms for smoother fade out/in
    }, 5000);

    return () => clearInterval(interval);
  }, [titles.length]);

  return (
    <div className="flex items-center justify-center">
      <div
        className={`titles-container rounded-full p-2 transition-all duration-800 transform ${
          !isVisible ? 'opacity-0 translate-y-4' : 
          isChanging ? 'opacity-0' : 'opacity-100 translate-y-0'
        }`}
        style={{
          backgroundColor: colors[index % colors.length],
          transitionProperty: 'opacity, transform, background-color',
          transitionDuration: '800ms',
        }}
      >
        <p className="desktop:text-4xl tablet:text-4xl phone: text-white font-bold px-8">
          {titles[index]}
        </p>
      </div>
    </div>
  );
}

export default RoleBadge; 